<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on" color="black">
        <v-icon left>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">Edit Client</v-card-title>
      <v-card-text>
        <!-- <p>{{ CustomerInfo }}</p> -->
        <v-form ref="EditeClientForm">
          <v-text-field
            v-model.trim="CustomerInfo.FullName"
            validate-on-blur
            :rules="[v => !!v || 'Full Name is required']"
            label="First Name"
            color="success"
            required
          >
          </v-text-field>

          <v-text-field
            type="number"
            v-model.number="CustomerInfo.Cusphone"
            validate-on-blur
            :rules="[v => !!v || 'Phone is required', minlength]"
            label="Phone"
            color="success"
            required
          >
          </v-text-field>

          <v-text-field
            v-model.trim="CustomerInfo.IDNomber"
            validate-on-blur
            :rules="[v => !!v || 'Passport or other ID is required']"
            label="ID Number"
            color="success"
            required
          >
          </v-text-field>
          <v-text-field
            v-model.number="CustomerInfo.share"
            validate-on-blur
            :rules="[v => !!v || 'Share % is required']"
            label="Profit Share %"
            color="success"
            required
          >
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" :disabled="clicked" text @click="close"
          >Cancel</v-btn
        >
        <v-btn
          color="green darken-1"
          :loading="clicked"
          text
          @click="OnEditeClient"
          >Save Edit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { ClientInfo: { type: Object, required: true } },
  data() {
    return {
      clicked: false,
      dialog: false,
      menu: false,
      ErrorMsg: "",
      CustomerInfo: {
        FullName: null,
        Cusphone: null,
        share: null,
        IDNomber: null,
      },
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.CustomerInfo.FullName = this.ClientInfo.FullName;
        this.CustomerInfo.Cusphone = this.ClientInfo.Cusphone;
        this.CustomerInfo.share = this.ClientInfo.share;
        this.CustomerInfo.IDNomber = this.ClientInfo.IDNomber;
        // this.ClientInfo.IDNomber = "12345";
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    OnEditeClient() {
      if (this.$refs.EditeClientForm.validate()) {
        this.clicked = true;
        this.CustomerInfo._id = this.ClientInfo._id;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: "/owner/Edit",
            data: {
              ...this.CustomerInfo,
            },
          })
          .then(result => {
            this.clicked = false;
            // console.log(result);
            // console.log(this.ClientInfo);
            // this.ClientInfo = result.data;
            this.ClientInfo.FullName = result.data.FullName;
            this.ClientInfo.Cusphone = result.data.Cusphone;
            this.ClientInfo.share = result.data.share;
            this.ClientInfo.IDNomber = result.data.IDNomber;
            this.close();
          })
          .catch(() => {
            this.clicked = false;
            // console.log(error);
          });
      }
    },
    close() {
      this.dialog = false;
      this.$refs.EditeClientForm.reset();
    },
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      // if (v && v.toString().length < 9)
      //   return "Phone length must be at least 9 number";
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
  mounted() {
    // console.log(this.ClientInfo);
    this.CustomerInfo.firstName = this.ClientInfo.firstName;
    this.CustomerInfo.otherNames = this.ClientInfo.otherNames;
    this.CustomerInfo.Cusphone = this.ClientInfo.Cusphone;
    this.CustomerInfo.DOB = this.ClientInfo.DOB;
    this.CustomerInfo.IDNomber = this.ClientInfo.IDNomber;
  },
};
</script>
